import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const transition = async (id, data) => {
  const response = await apiClient({
    baseURL,
    method: 'POST',
    url: `/delivery-order/${id}/transition`,
    data,
  })

  return response?.data
}



export const bulkTransition = async (data) => {
  const response = await apiClient({
    baseURL,
    method: 'POST',
    url: `/delivery-order/transition`,
    data,
  })

  return response?.data
}
